// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--2Fy8vxtH2"};